module.exports = __webpack_public_path__ + "img/product-ketang-jbg-05.52607216.png";